import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSatisfaction = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 120 120",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M60 10        L71.76 41.18        L104 44.51        L78 66.32        L85.52 98        L60 80        L34.48 98        L42 66.32        L16 44.51        L48.24 41.18        Z",
		fill: "currentColor",
		stroke: "currentColor",
		strokeWidth: 6,
		strokeLinejoin: "round",
		strokeLinecap: "round"
	})
});
export default SvgSatisfaction;
